<template>
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6 h-fit md:min-h-[367px]">
        <div>
            <component :is="leftComponent" :content="leftSlot" />
        </div>
        <div>
            <component :is="centerLeftComponent" :content="centerLeftSlot" />
        </div>
        <div>
            <component :is="centerRightComponent" :content="centerRightSlot" />
        </div>
        <div>
            <component :is="rightComponent" :content="rightSlot" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { HblSlot } from '@/utils/types'
import { hblToUpperCamelCase } from '@/utils/helper'

const props = defineProps<{
    content: HblSlot[]
}>()

const leftSlot = computed(() => {
    return props.content.find(item => item.position === 'left')
})

const centerLeftSlot = computed(() => {
    return props.content.find(item => item.position === 'centerLeft')
})

const centerRightSlot = computed(() => {
    return props.content.find(item => item.position === 'centerRight')
})

const rightSlot = computed(() => {
    return props.content.find(item => item.position === 'right')
})

const leftComponent = computed(() => {
    if (!leftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(leftSlot.value.type)}`
})

const centerLeftComponent = computed(() => {
    if (!centerLeftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(centerLeftSlot.value.type)}`
})

const centerRightComponent = computed(() => {
    if (!centerRightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(centerRightSlot.value.type)}`
})

const rightComponent = computed(() => {
    if (!rightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(rightSlot.value.type)}`
})
</script>
